import { User, UserDetail, HouseUser} from '../../entities/profile/profile.model';

export class UserDTO {
    firstName: string;
    lastName: string;
    email: string;
    houseId: string;
    permissionRole: string;
    receiveReport: number;
    receivePush: number;
    receiveEmail: number;
     static fromDto(userDTO: UserDTO): User {
        return new User(userDTO.houseId, userDTO.permissionRole, userDTO.receiveReport, userDTO.receivePush,
            userDTO.receiveEmail, userDTO.firstName, userDTO.lastName, userDTO.email);
    }
}

export class UserDetailDTO {
    firstName: string;
    lastName: string;
    email: string;
    userId: string;
    creationDate: string;
    lastLogin: string;
    languageCode: string;
    identityId: string;
     static fromDto(userDTO: UserDetailDTO): UserDetail {
        return new UserDetail(userDTO.firstName, userDTO.lastName, userDTO.email, userDTO.userId,
            userDTO.creationDate, userDTO.lastLogin, userDTO.languageCode, userDTO.identityId);
    }
}

export class HouseUsersWrapperDTO {
    houseUsers: HouseUserDTO;
}

export class HouseUserDTO {
    firstName: string;
    lastName: string;
    email: string;
    houseId: string;
    permissionRole: string;
    receiveReport: boolean;
    receivePush: boolean;
    receiveEmail: boolean;
    languageCode: string;

    static fromHouseUserDto(userDTO: HouseUserDTO): HouseUser {
        return new HouseUser(userDTO.houseId, userDTO.permissionRole, userDTO.receiveReport, userDTO.receivePush, userDTO.receiveEmail,
            userDTO.firstName, userDTO.lastName, userDTO.email, userDTO.languageCode);
    }

    static toHouseUserDto(houseUser: HouseUser) {
        const houseUserDTO: HouseUserDTO = new HouseUserDTO();
        houseUserDTO.email = houseUser.email;
        houseUserDTO.firstName = houseUser.firstName;
        houseUserDTO.lastName = houseUser.lastName;
        houseUserDTO.languageCode = houseUser.languageCode;
        houseUserDTO.receiveReport = houseUser.receiveReport;
        houseUserDTO.permissionRole = houseUser.permissionRole;
        houseUserDTO.receivePush = houseUser.receivePush;
        houseUserDTO.receiveEmail = houseUser.receiveEmail;

        return houseUserDTO;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/DTO/UserDTO.ts